import { Users, Home, Building2, Wrench } from 'lucide-react';

export type UserRole = 'board' | 'owner' | 'tenant' | 'janitor' | null;

export const USER_ROLES = {
  BOARD: 'board',
  OWNER: 'owner',
  TENANT: 'tenant',
  JANITOR: 'janitor'
} as const;

export const ROLE_CONFIG = {
  [USER_ROLES.BOARD]: {
    id: USER_ROLES.BOARD,
    label: 'Styremedlem',
    description: 'Har tilgang til administrative funksjoner',
    icon: Users
  },
  [USER_ROLES.OWNER]: {
    id: USER_ROLES.OWNER,
    label: 'Eier',
    description: 'Eier av leiligheten',
    icon: Home
  },
  [USER_ROLES.TENANT]: {
    id: USER_ROLES.TENANT,
    label: 'Leietaker',
    description: 'Leier leiligheten',
    icon: Building2
  },
  [USER_ROLES.JANITOR]: {
    id: USER_ROLES.JANITOR,
    label: 'Vaktmester',
    description: 'Har tilgang til vedlikeholdsfunksjoner',
    icon: Wrench
  }
} as const;

// Hjelpefunksjoner for å sjekke roller
export const isBoardMember = (role: UserRole): boolean => {
  return role === USER_ROLES.BOARD;
};

export const isOwner = (role: UserRole): boolean => {
  return role === USER_ROLES.OWNER;
};

export const isTenant = (role: UserRole): boolean => {
  return role === USER_ROLES.TENANT;
};

export const isJanitor = (role: UserRole): boolean => {
  return role === USER_ROLES.JANITOR;
};

export const hasAdminAccess = (role: UserRole): boolean => {
  return role === USER_ROLES.BOARD;
}; 